export const LOCAL_STORAGE_KEYS = {
  /** Enables staging PostHog tracking in development in this browser. */
  ENABLE_DEVELOPMENT_POSTHOG: 'ENABLE_DEVELOPMENT_POSTHOG',
  /** Enables Braintrust and Temporal links outside KG tools in this browser. */
  SHOW_BRAINTRUST_LINKS: 'SHOW_BRAINTRUST_LINKS',
  /**
   * Set when user visits ClientDetailsEstateWaterfallDiagramPage or
   * ClientDetailsEstateWaterfallSummaryPage. Used on ClientDetailsEstateWaterfallBasePage
   * to determine which waterfall to navigate to.
   */
  LAST_VIEWED_WATERFALL: 'LAST_VIEWED_WATERFALL',
  LAST_VIEWED_ENTITY_MAP: 'LAST_VIEWED_ENTITY_MAP',
  LAST_VIEWED_HOUSEHOLDS: 'LAST_VIEWED_HOUSEHOLDS',
  /** Set when a user dismisses the "Disable this toggle before creating your last entity" coachmark */
  COACHMARK_ENTITY_CREATE: 'COACHMARK_ENTITY_CREATE',
  COACHMARK_COPY_DISPOSITIVE_PROVISIONS:
    'COACHMARK_COPY_DISPOSITIVE_PROVISIONS',
  /** Set when a user acknowledges the coachmark after first expanding an entity in the bulk import table */
  COACHMARK_EXPAND_BULK_IMPORT_ENTITY: 'COACHMARK_EXPAND_BULK_IMPORT_ENTITY',
  WATERFALL_SUMMARY_TILE_DETAILS: 'WATERFALL_SUMMARY_TILE_DETAILS',
  COACHMARK_SEEN_PREFIX: 'coachmark_seen_',

  /** Set when a user acknowledges the coachmark for clicking the magnifying glass to cycle through evidence */
  COACHMARK_CITATION_TOOLTIP: 'COACHMARK_CITATION_TOOLTIP',
  /** Tracks notification status for the most recently created hypothetical item */
  HYPOTHETICAL_ITEM_NOTIFICATION: 'HYPOTHETICAL_ITEM_NOTIFICATION',
  /** Tracks expanded state of the "Get started with your next deliverable" accordion */
  DELIVERABLE_ACCORDION_EXPANDED: 'DELIVERABLE_ACCORDION_EXPANDED',
  /** Tracks expanded state of the model analysis tiles accordion */
  MODEL_ANALYSIS_ACCORDION_EXPANDED: 'MODEL_ANALYSIS_ACCORDION_EXPANDED',
  /** Tracks expanded state of the AI suggestion review card accordion */
  AI_SUGGESTION_REVIEW_ACCORDION_EXPANDED:
    'AI_SUGGESTION_REVIEW_ACCORDION_EXPANDED',
  /** Tracks dismissed state of the tax shortfall callout */
  TAX_SHORTFALL_DISMISSED: 'TAX_SHORTFALL_DISMISSED',
  /** Tracks dismissed state of the tax explanation banner per household. */
  TAX_EXPLANATION_BANNER_DISMISSED: 'TAX_EXPLANATION_BANNER_DISMISSED',
  /** Tracks the "Keep me logged in for 30 days" checkbox state during magic code authentication */
  REMEMBER_EXTENDED_SESSION: 'REMEMBER_EXTENDED_SESSION',
  /** Tracks which feature announcements have been viewed by the user */
  FEATURE_ANNOUNCEMENTS_VIEWED: 'FEATURE_ANNOUNCEMENTS_VIEWED',
  /** Tracks dismissed state of the missing beneficiaries callout */
  MISSING_BENEFICIARIES_CALLOUT_DISMISSED:
    'MISSING_BENEFICIARIES_CALLOUT_DISMISSED',
  /** Tracks the persisted desktop width of the docked household chat pane */
  HOUSEHOLD_CHAT_WIDTH: 'HOUSEHOLD_CHAT_WIDTH',
  /** Tracks the persisted width of the section rail in the admin form builder */
  FORM_BUILDER_SECTION_RAIL_WIDTH: 'FORM_BUILDER_SECTION_RAIL_WIDTH',
  /** Tracks the persisted width of the question settings panel in the admin form builder */
  FORM_BUILDER_INSPECTOR_WIDTH: 'FORM_BUILDER_INSPECTOR_WIDTH',
  /** Tracks expanded state of the "About this document" accordion on the document details page */
  DOCUMENT_DETAILS_ABOUT_ACCORDION_EXPANDED:
    'DOCUMENT_DETAILS_ABOUT_ACCORDION_EXPANDED',
  /** Tracks expanded state of the "Manage codicils/amendments" accordion on the document details page */
  DOCUMENT_DETAILS_AMENDMENTS_ACCORDION_EXPANDED:
    'DOCUMENT_DETAILS_AMENDMENTS_ACCORDION_EXPANDED',
  /** Tracks expanded state of the "About this memo" accordion on the memo details page */
  MEMO_DETAILS_ABOUT_ACCORDION_EXPANDED:
    'MEMO_DETAILS_ABOUT_ACCORDION_EXPANDED',
  /** Tracks dismissed state of the diagram multiselect hint in the presentation diagram edit trowser */
  DIAGRAM_MULTISELECT_HINT_DISMISSED: 'DIAGRAM_MULTISELECT_HINT_DISMISSED',
  /**
   * Tracks dismissed state of the balance sheet unacknowledged suggestions
   * banner. Keyed per household and stores the set of suggestion IDs that were
   * present when the user dismissed the banner so it can re-appear when new
   * suggestions show up.
   */
  BALANCE_SHEET_SUGGESTIONS_BANNER_DISMISSED:
    'BALANCE_SHEET_SUGGESTIONS_BANNER_DISMISSED',
  /**
   * Tracks dismissed state of the AI Suggestions V2 announcement banner
   * (shown at the top of People, Direct Holdings, Trusts, and Businesses
   * tabs when a household still has outstanding v1 suggestions). Keyed per
   * household; once dismissed it stays dismissed across all four tabs.
   */
  AI_SUGGESTIONS_V2_BANNER_DISMISSED: 'AI_SUGGESTIONS_V2_BANNER_DISMISSED',
  /** Tracks the last dismissed SmartReview presentation banner per household */
  SMART_REVIEW_PRESENTATION_BANNER_DISMISSED:
    'SMART_REVIEW_PRESENTATION_BANNER_DISMISSED',
  /** Prefix for setup completion dismissal, followed by household and onboarding completion tracker IDs. */
  HOUSEHOLD_SETUP_COMPLETION_DISMISSED: 'household-setup-dismissed',
  /** Prefix for this browser's initial onboarding run, followed by household ID. */
  INITIAL_HOUSEHOLD_SETUP: 'initial-household-setup',
  /** Prefix for no-documents overview dismissal, followed by household ID. */
  HOUSEHOLD_NO_DOCUMENTS_DISMISSED: 'household-no-documents-dismissed',
} as const;
